import script from "./SAM2ClickPoint.vue?vue&type=script&setup=true&lang=js"
export * from "./SAM2ClickPoint.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__